import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { getTurnstilePublicKey } from "@/cloudflare/turnstile"
import { breadcrumbJsonLd, buildHead } from "@/core/seo"
import { NewsletterSignup } from "@/newsletter/components/newsletter-signup"

import { Breadcrumb } from "../components/landing"

export const waitlistSeo = () =>
  buildHead({
    title: "Join the waitlist",
    description:
      "Kestly opens soon. Leave your email and we will send one message when mileage, receipts and invoices for Australian sole traders open.",
    path: "/waitlist",
    noindex: true,
    jsonLd: [breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Waitlist" }])],
  })

export const Route = createFileRoute("/_brand-layout/waitlist")({
  head: () => {
    const { meta, links, scripts } = waitlistSeo()
    return { meta, links, scripts }
  },
  component: WaitlistRoute,
})

/** The page is prerendered, so the per-environment Turnstile key is fetched in the browser. */
function WaitlistRoute() {
  const { data } = useQuery({ queryKey: ["waitlist-page"], queryFn: () => getTurnstilePublicKey() })
  return <WaitlistPage cloudflareTurnstilePublicKey={data?.cloudflareTurnstilePublicKey} />
}

export function WaitlistPage({
  cloudflareTurnstilePublicKey,
}: {
  cloudflareTurnstilePublicKey?: string
}) {
  return (
    <>
      <Breadcrumb items={[{ label: "Home", href: "/" }, { label: "Waitlist" }]} />
      <header className="bg-muted/40 px-band py-8 md:py-12">
        <h1 className="text-3xl font-bold tracking-tight md:text-5xl">Join the waitlist</h1>
        <p className="text-muted-foreground mt-3 max-w-[60ch] text-lg">
          Kestly is coming soon. Leave your email and we will send one message when it opens. We
          email you a link to confirm, and every message has an unsubscribe link. See the{" "}
          <a
            href="/legal/privacy"
            className="focus-visible:ring-ring rounded-sm underline underline-offset-2 outline-none focus-visible:ring-2"
          >
            privacy policy
          </a>
          .
        </p>
      </header>
      <section className="px-band py-8">
        <NewsletterSignup
          cloudflareTurnstilePublicKey={cloudflareTurnstilePublicKey}
          className="max-w-xl"
          submitLabel="Join the waitlist"
        />
      </section>
    </>
  )
}
